export { SearchResultsDS } from './search-results-ds'
export type { SearchResultsDSProps } from './search-results-ds'
